import init from './init';

export default () => {
  document.addEventListener('shopify:section:load', (e) => {
    const sectionId = e.detail.sectionId;
    const sections = document.querySelectorAll(`[data-section-id="${sectionId}"]`);
    sections.forEach((section) => init(section));
  });
};
